const SEED_TEMPLATES = "SEED_TEMPLATES";

export {
  SEED_TEMPLATES,
};
